import dayjs from "dayjs"
import { DateOnly, DateTime } from "../@client/System"

export function getFormattedDate(
  date: Date | DateOnly | DateTime | string | null | undefined,
  format: string = "L"
) {
  return !!date ? dayjs(date).format(format) : ""
}

export function getFormattedDatePeriod(
  date: {
    start: DateOnly | string | null | undefined
    end: DateOnly | string | null | undefined
  },
  format: string = "L"
) {
  const startDate = !!date.start ? getFormattedDate(date.start, format) : ""
  const endDate = !!date.end ? getFormattedDate(date.end, format) : ""
  if (startDate === endDate) {
    return startDate
  }
  return (
    date &&
    `${!!date.start ? getFormattedDate(date.start, format) : ""}${!!date.end ? "-" : ""}${
      !!date.end ? getFormattedDate(date.end, format) : ""
    }`
  )
}
